export const nasaParticle = {
  style: {
    zIndex: -1,
  },
  background: {
    color: {
      value: '#DBE7FF',
    },
  },
  fpsLimit: 120,
  interactivity: {
    modes: {
      bubble: {
        distance: 400,
        duration: 2,
        opacity: 0.5,
        size: 30,
      },
      push: {
        quantity: 1,
      },
      repulse: {
        distance: 300,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: '#71a7ff',
    },
    links: {
      color: '#71a7ff',
      distance: 150,
      enable: true,
      opacity: 0.5,
      width: 1,
    },
    collisions: {
      enable: true,
    },
    move: {
      direction: 'none',
      enable: true,
      outMode: 'bounce',
      random: false,
      speed: 0.8,
      straight: false,
    },
    number: {
      density: {
        enable: true,
        area: 2200,
      },
      value: 80,
    },
    opacity: {
      value: 0.5,
    },
    shape: {
      type: 'circle',
    },
    size: {
      random: true,
      value: 5,
    },
  },
  detectRetina: true,
}
